<template>
  <div
    v-show="!isApp"
    :class="[
      'detail-page-header',
      headerClassName,
      isDesktop ? 'pc-header' : 'mobile-header',
    ]"
    :style="hackZindexStyle"
  >
    <div class="app-info" @click="goHome">
      <!--      <img
        v-lazy="require(`@/assets/images/common/logo.png`)"
        class="app-icon"
        alt="app-icon"
      />-->
      <img
        v-lazy="require(`@/assets/images/common/toplupe-logo.png`)"
        class="app-icon text"
        alt="app-icon"
      />
    </div>
    <div class="right-area" v-show="showRightArea">
      <div class="share-btn">
        <slot></slot>
      </div>
      <region-lang-popup :page="gameName" v-show="!isGenshinEn" />
      <UserCenter
        :page="gameName"
        ref="loginComp"
        @login="getLoginResult"
        v-show="!isGenshinEn"
      />
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { backHome } from '@/pages/firebase'
  import UserCenter from '@/components/UserCenter'
  import RegionLangPopup from '@/components/RegionLangPopup'
  import { hideLoginRegions } from '@/consts/index.js'

  export default {
    name: 'detail-header',
    props: {
      headerClassName: {
        type: String,
        default: '',
      },
    },
    components: {
      UserCenter,
      RegionLangPopup,
    },
    computed: {
      ...mapState([
        'gameName',
        'isApp',
        'source',
        'region',
        'isGetapps',
        'isDesktop',
        'watchCouponState',
      ]),
      ...mapGetters(['displayDesktop', 'isGenshinEn']),

      // hack 解决层级的问题
      // popup vant版本较低【下次优化】
      hackZindexStyle() {
        return {
          zIndex: this.watchCouponState ? 1 : 3,
        }
      },
      showRightArea() {
        return !this.isGetapps && hideLoginRegions.indexOf(this.region) < 0
      },
    },
    methods: {
      goHome() {
        if (this.isGenshinEn || this.isGetapps) {
          return
        }
        const { gameName } = this
        backHome({ page: gameName })
        let query = { source: this.source }
        this.isPwa && Object.assign(query, { isPwa: true })
        if (this.$route.query.home === 'true') {
          this.$router_push({
            path: `/home`,
            query: {
              ...this.$route.query,
              ...query,
            },
          })
        } else {
          this.$router_push({
            path: `/`,
            query: {
              ...this.$route.query,
              ...query,
            },
          })
        }
      },
      login(type = '') {
        this.$refs.loginComp && this.$refs.loginComp.loginBtn(type)
      },
      getLoginResult(res) {
        this.$emit('login', res)
      },
    },
  }
</script>

<style scoped lang="scss" src="./base.scss"></style>

<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './base.scss';
  }
</style>
